<template>
  <tooltip placement="top" :options="{ hideOnClick: true }">
    <template #trigger>
      <div>
        {{ secondsLabel }}
      </div>
    </template>
    <template #tooltip>
      <div>{{ tooltipContent }}</div>
    </template>
  </tooltip>
</template>

<script>
import { isFalsy } from "@/lib/helpers.js";

import Tooltip from "@/components/Tooltip.vue";
import { formatDurationSeconds } from "@/mixins";

export default {
  components: {
    Tooltip
  },
  props: {
    seconds: {
      type: Number,
      default: null
    },
    defaultText: {
      type: String,
      default: "No Data"
    },
    notAvailable: {
      type: Boolean,
      default: false
    },
    notAvailableText: {
      type: String,
      default: "Not Available"
    }
  },
  computed: {
    secondsLabel() {
      if (this.notAvailable) {
        return "N/A";
      }
      if (isFalsy(this.seconds)) {
        return "--";
      }
      return formatDurationSeconds(this.seconds);
    },
    tooltipContent() {
      if (this.notAvailable) {
        return this.notAvailableText;
      }
      if (isFalsy(this.seconds)) {
        return this.defaultText;
      }
      return `${(this.seconds || 0).toLocaleString()} seconds`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
